<template lang="">
  <router-view></router-view>
</template>

<script>
export default {

  name: 'SeguimientoDiario',
  data () {
    return {
    }
  }
  
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/seguimiento-diario.vue